module.exports = __webpack_public_path__ + "files/SPIADI2019 - Présentation JHH.bc24474f907c966915c8979b0fb782d5.pdf";